// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Layout_Wrapper__2JZNi","Main":"Layout_Main__Vm9LA","Content":"Layout_Content__3H3X8","Curved":"Layout_Curved__3IeoP"};